import * as PopoverPrimitive from '@radix-ui/react-popover';
import clsx from 'clsx';
import CloseIcon from '~/icons/close.svg';
import InfoIcon from '~/icons/information.svg';
import styles from './ProductPopover.module.scss';
import { useTranslation } from '~/shared/utils/translation';

type ContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>;

interface Props extends ContentProps {
    trigger?: React.ReactNode;
    triggerClassName?: string;
}

export const ProductPopover: React.FC<Props> = ({
    className,
    children,
    trigger,
    triggerClassName,
    ...rest
}) => {
    const { translate } = useTranslation();

    return (
        <PopoverPrimitive.Root>
            <PopoverPrimitive.Trigger
                className={clsx(styles.productPopoverTrigger, triggerClassName)}
                aria-label={translate('accessibility.tooltipLabel')}
            >
                {trigger ?? <InfoIcon aria-hidden="true" focusable="false" />}
            </PopoverPrimitive.Trigger>

            <PopoverPrimitive.Portal>
                <PopoverPrimitive.Content
                    className={clsx(styles.productPopoverContent, className)}
                    side="bottom"
                    align="center"
                    sideOffset={8}
                    {...rest}
                >
                    <PopoverPrimitive.Close
                        className={styles.productPopoverClose}
                        aria-label={translate('accessibility.closeIconTitle')}
                    >
                        <CloseIcon aria-hidden="true" focusable="false" />
                    </PopoverPrimitive.Close>

                    {children}
                </PopoverPrimitive.Content>
            </PopoverPrimitive.Portal>
        </PopoverPrimitive.Root>
    );
};
